/**
 * Security Utilities
 * XSS önleme ve güvenli veri işleme fonksiyonları
 */

export const security = {
    /**
     * HTML etiketlerini temizler (Basic XSS Protection)
     * @param {string} input - Güvensiz metin
     * @returns {string} - Temizlenmiş (escaped) metin
     */
    sanitizeHTML: function (input) {
        if (!input) return '';
        if (typeof input !== 'string') return String(input);

        // Map of characters to escape
        const map = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#039;'
        };

        return input.replace(/[&<>"']/g, function (m) { return map[m]; });
    },

    /**
     * Güvenli olmayan karakterleri regex ile temizler (Daha sıkı)
     */
    cleanInput: function (input) {
        if (!input) return '';
        // Sadece harf, rakam, boşluk ve temel noktalama işaretlerine izin ver
        return input.replace(/[^a-zA-Z0-9 öçşğüıÖÇŞĞÜİ.,?!:;@()\-]/g, '');
    }
};

// Global erişim (Opsiyonel, modül sistemi kullanılması önerilir)
window.security = security;
